import { useSelector } from "react-redux";
import { useState } from "react";
import UpdateContactModal from "./userInfoComponents/UpdateContactModal";

const ContactInfo = () => {
    const user = useSelector((state) => state.auth.user);
    const [isModalOpen, setIsModalOpen] = useState(false);

    if (!user) {
        return null;
    }

    const handleUpdateClick = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <div className="mb-4 text-left">
                <h2 className="text-card-title font-semibold tracking-tight text-ink">Contact Information</h2>
                <p className="text-body text-ink-3">Primary account and company details.</p>
            </div>

            <div className="w-full rounded-xl border border-border bg-surface-2 p-6">
                <ul className="space-y-3 text-body text-ink-2">
                    <li className="capitalize"><span className="font-semibold text-ink">Company Name:</span> {user.company}</li>
                    <li><span className="font-semibold text-ink">E-mail:</span> {user.email}</li>
                    <li className="capitalize"><span className="font-semibold text-ink">Contact Person:</span> {user.name}</li>
                </ul>
                <div className="text-right mt-4">
                    <button
                        className="inline-flex h-10 items-center rounded-md bg-ink px-4 text-label font-medium text-white transition hover:bg-ink-2"
                        onClick={handleUpdateClick}
                    >
                        Update Contact
                    </button>
                </div>
            </div>

            {isModalOpen && <UpdateContactModal user={user} onClose={handleCloseModal} />}
        </>
    );
};

export default ContactInfo;
